import api from './api';

class CardService {
  async getCollections(deactivated = false) {
    return await api
      .get(`/card/collection?deactivated=${deactivated}`)
      .then(async (response) => {
        return response.data.collections;
      });
  }

  async deactivateCollection(collection_uuid) {
    return await api
      .post(`/card/collection/deactivate`, {collection_uuid})
      .then(async (response) => {
        return response.data;
      });
  }

  async activateCollection(collection_uuid) {
    return await api
      .post(`/card/collection/reactivate`, {collection_uuid})
      .then(async (response) => {
        return response.data;
      });
  }

  async createCollection(name, description) {
    return await api
      .post(`/card/collection`, {name, description})
      .then(async (response) => {
        return response.data;
      });
  }

  async updateCollection(collection_uuid, name, description) {
    return await api
      .post(`/card/collection/${collection_uuid}`, {name, description})
      .then(async (response) => {
        return response.data;
      });
  }

  async getCollectionBuds(collection, deactivated = false, target) {
    return await api
      .get(`/card/bud?deactivated=${deactivated}&collection=${collection}${target && target !== "all"? `&target=${target}` : "" }`)
      .then(async (response) => {
        return response.data.available_buds;
      });
  }

  async getCollectionNumber(collection) {
    return await api
      .get(`/card/bud?collection=${collection}`)
      .then(async (response) => {
        return response.data.available_buds.length + 1;
      });
  }

  async getBuds(deactivated = false, target) {
    return await api
      .get(`/card/bud?deactivated=${deactivated}${target && target !== "all"? `&target=${target}` : "" }`)
      .then(async (response) => {
        return response.data.available_buds;
      });
  }

  async getLevels() {
    return await api
      .get(`/card/level`)
      .then(async (response) => {
        return response.data.levels;
      });
  }

  async createBud(level, level_max, img_data, thumbnail, bud_name, description, collection_uuid, target, discord, twitter) {
    return await api
      .post(`/card/bud`, {level, level_max, img_data, thumbnail, bud_name, description, collection_uuid, target, discord, twitter})
      .then(async (response) => {
        return response.data;
      });
  }

  async updateBud(bud_uuid, level, level_max, img_data, thumbnail, bud_name, description, collection_uuid) {
    return await api
      .post(`/card/bud/${bud_uuid}`, {level, level_max, img_data, thumbnail, bud_name, description, collection_uuid})
      .then(async (response) => {
        return response.data;
      });
  }

  async updateBudSale(bud_sale_uuid, price, max_sales, start_sale, end_sale, sale_status, xp) {
    return await api
      .post(`/card/bud/sale/${bud_sale_uuid}`, {price, max_sales, start_sale, end_sale, sale_status: (sale_status.toString() === 'true'), xp})
      .then(async (response) => {
        return response.data;
      });
  }

  async newBudSale(bud_uuid, price, max_sales, start_sale, end_sale, xp) {
    return await api
      .post(`/card/bud/sale`, {bud_uuid, price, max_sales, start_sale, end_sale, xp})
      .then(async (response) => {
        return response.data;
      });
  }

  async deactivateBud(bud_uuid) {
    return await api
      .post(`/card/bud/deactivate`, {bud_uuid})
      .then(async (response) => {
        return response.data;
      });
  }

  async activateBud(bud_uuid) {
    return await api
      .post(`/card/bud/reactivate`, {bud_uuid})
      .then(async (response) => {
        return response.data;
      });
  }

  async getBusinessCards() {
    return await api
      .get(`/card/bud/sale?target=business`)
      .then(async (response) => {
        return response.data.current_sale;
      });
  }

  async getUnitPrice() {
    return await api
      .get(`/card/bud/sale?target=business`)
      .then(async (response) => {
        return response.data.card_unit_price;
      });
  }

  async purchaseBusinessBud(bud_uuid, nb_card = 100) {
    return await api
      .post(`/card/bud/buy`, {bud_uuid, nb_card})
      .then(async (response) => {
        return response.data.status;
      });
  }

  async sendBudToPlayer(bud_uuid, player_uuid, card_power = null) {
    const body = {bud_uuid, player_uuid};
    if (card_power !== null && card_power !== undefined) body.card_power = card_power;
    return await api
      .post(`/card/bud/player`, body)
      .then(async (response) => {
        return response.data;
      });
  }

  // ---------- Packs / Boosters ----------
  async getPacks(active = true) {
    return await api
      .get(`/card/pack?active=${active}`)
      .then(async (response) => {
        return response.data;
      });
  }

  async getPack(pack_uuid, start_date = null, end_date = null) {
    const params = new URLSearchParams()
    if (start_date) params.append('start_date', start_date)
    if (end_date) params.append('end_date', end_date)
    const query = params.toString()
    return await api
      .get(`/card/pack/${pack_uuid}${query ? `?${query}` : ''}`)
      .then(async (response) => {
        return response.data;
      });
  }

  async createPack(payload) {
    return await api
      .post(`/card/pack`, payload)
      .then(async (response) => {
        return response.data;
      });
  }

  async updatePack(pack_uuid, payload) {
    return await api
      .post(`/card/pack/${pack_uuid}`, payload)
      .then(async (response) => {
        return response.data;
      });
  }

  async deactivatePack(pack_uuid) {
    return await api
      .post(`/card/pack/deactivate`, {pack_uuid})
      .then(async (response) => {
        return response.data;
      });
  }

  async activatePack(pack_uuid) {
    return await api
      .post(`/card/pack/activate`, {pack_uuid})
      .then(async (response) => {
        return response.data;
      });
  }

  async setPackDefault(pack_uuid) {
    return await api
      .post(`/card/pack/default`, {pack_uuid})
      .then(async (response) => {
        return response.data;
      });
  }

  async getPackFiles() {
    return await api
      .get(`/card/pack/files`)
      .then(async (response) => {
        return response.data.pack_files;
      });
  }
}
// eslint-disable-next-line
export default new CardService();